"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { PageHero } from "@/components/layout/PageHero";
import { SitePageShell } from "@/components/layout/SitePageShell";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";
import { sitemapPage, sitemapSections } from "@/content/sitemap";

export function SitemapPageView() {
  return (
    <SitePageShell className="pb-16">
      <PageHero
        eyebrow={sitemapPage.eyebrow}
        title={sitemapPage.title}
        subtitle={sitemapPage.subtitle}
        align="center"
      />

      <section className="site-section !pt-0">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <Stagger className="space-y-6">
            {sitemapSections.map((section) => (
              <StaggerItem key={section.id}>
                <Reveal>
                  <div className="site-card p-6 md:p-8">
                    <h2 className="mb-4 font-display text-xl font-semibold text-[var(--site-primary)]">
                      {section.title}
                    </h2>
                    <ul className="space-y-2">
                      {section.links.map((link) => (
                        <li key={link.href}>
                          <Link
                            href={link.href}
                            className="group flex items-center gap-2 text-sm text-[var(--site-muted)] transition-colors hover:text-[var(--site-accent)]"
                          >
                            <ChevronRight
                              size={14}
                              className="shrink-0 text-[var(--site-accent)] transition-transform group-hover:translate-x-0.5"
                              aria-hidden
                            />
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>
              </StaggerItem>
            ))}
          </Stagger>

          <p className="mt-10 text-center text-sm text-[var(--site-muted)]">
            {sitemapPage.xmlNote}{" "}
            <Link
              href={sitemapPage.xmlHref}
              className="font-medium text-[var(--site-accent)] hover:underline"
            >
              XML sitemap
            </Link>
            .
          </p>

          <p className="mt-6 text-center">
            <Link
              href="/"
              className="text-sm font-medium text-[var(--site-accent)] hover:underline"
            >
              &larr; Back to Home
            </Link>
          </p>
        </div>
      </section>
    </SitePageShell>
  );
}
